import {DocumentFormProps} from "./DocumentForm";
import {FieldDate, FieldInput} from "@kroschke/react-ui";
import {DocumentFormReceiver} from "./DocumentFormReceiver";
import {DocumentFormDefault} from "./DocumentFormDefault";

function DocumentFormCorI({
                              disabled,
                              value,
                              onBlur,
                              validation,
                              onChange
                          }: DocumentFormProps) {
    return <>
        <div className={"columns"}>
            <div className={"column is-one-third"}>
                <FieldInput
                    disabled={disabled}
                    label={"ZB1 Nummer"}
                    required={true}
                    maxLength={20}
                    value={value.corSerial || ''}
                    help={validation.corSerial}
                    invalid={Boolean(validation.corSerial)}
                    onBlur={() => !disabled && onBlur()}
                    inputTransform={e => e.toUpperCase()}
                    onChange={corSerial => {
                        onChange({
                            ...value,
                            corSerial: corSerial
                        })
                    }}
                />
            </div>
            <div className={"column is-one-third"}>
                <FieldInput
                    disabled={disabled}
                    label={"FIN Prüfziffer"}
                    required={true}
                    maxLength={1}
                    value={value.vinCheckDigit || ''}
                    help={validation.vinCheckDigit}
                    invalid={Boolean(validation.vinCheckDigit)}
                    onBlur={() => !disabled && onBlur()}
                    inputTransform={e => e.toUpperCase()}
                    onChange={vinCheckDigit => {
                        onChange({
                            ...value,
                            vinCheckDigit: vinCheckDigit
                        })
                    }}
                />
            </div>
            <div className={"column is-one-third"}>
                <FieldInput
                    disabled={disabled}
                    label={"Kennzeichen"}
                    value={value.licensePlate || ''}
                    help={validation.licensePlate}
                    invalid={Boolean(validation.licensePlate)}
                    onBlur={() => !disabled && onBlur()}
                    inputTransform={e => e.toUpperCase()}
                    onChange={licensePlate => {
                        onChange({
                            ...value,
                            licensePlate: licensePlate
                        })
                    }}
                />
            </div>
        </div>
        <div className={"columns"}>
            <div className={"column is-one-third"}>
                <FieldDate
                    disabled={disabled}
                    label={"Erstzulassungsdatum"}
                    value={value.registrationDateFirst}
                    help={validation.registrationDateFirst}
                    invalid={Boolean(validation.registrationDateFirst)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={registrationDateFirst => {
                        onChange({
                            ...value,
                            registrationDateFirst: registrationDateFirst
                        })
                    }}
                />
            </div>
            <div className={"column is-one-third"}>
                <FieldDate
                    disabled={disabled}
                    label={"Zulassungsdatum (aktuell)"}
                    value={value.registrationDateLatest}
                    help={validation.registrationDateLatest}
                    invalid={Boolean(validation.registrationDateLatest)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={registrationDateLatest => {
                        onChange({
                            ...value,
                            registrationDateLatest: registrationDateLatest
                        })
                    }}
                />
            </div>
            <div className={"column is-one-third"}>
                <FieldDate
                    disabled={disabled}
                    label={"Abmeldedatum"}
                    value={value.deregistrationDate}
                    help={validation.deregistrationDate}
                    invalid={Boolean(validation.deregistrationDate)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={deregistrationDate => {
                        onChange({
                            ...value,
                            deregistrationDate: deregistrationDate
                        })
                    }}
                />
            </div>
        </div>
        <DocumentFormDefault
            disabled={disabled}
            value={value}
            validation={validation}
            onChange={onChange}
            onBlur={onBlur}
        />
        <DocumentFormReceiver
            disabled={disabled}
            value={value}
            validation={validation}
            onChange={onChange}
            onBlur={onBlur}
        />
    </>
}

export {
    DocumentFormCorI
}
